import { css as g, LitElement as b, html as n, nothing as p } from "lit";
import { property as i, customElement as x, state as w } from "lit/decorators.js";
import { classMap as u } from "lit/directives/class-map.js";
import { b as y } from "./styles-scZ6dVz-.js";
var $ = Object.defineProperty, k = Object.getOwnPropertyDescriptor, m = (a, r, s, t) => {
  for (var e = t > 1 ? void 0 : t ? k(r, s) : r, o = a.length - 1, l; o >= 0; o--)
    (l = a[o]) && (e = (t ? l(r, s, e) : l(e)) || e);
  return t && e && $(r, s, e), e;
};
let v = class extends b {
  constructor() {
    super(...arguments), this.orientation = "vertical", this.size = "md", this.collapsed = !1;
  }
  render() {
    const a = {
      nav: !0,
      [this.orientation]: !0,
      [`size-${this.size}`]: !0,
      collapsed: this.collapsed && this.orientation === "vertical"
    };
    return n`
      <nav part="nav" class=${u(a)} role="navigation">
        <slot></slot>
      </nav>
    `;
  }
};
v.styles = [
  y,
  g`
      :host {
        display: block;
      }

      *,
      *::before,
      *::after {
        box-sizing: border-box;
      }

      .nav {
        display: flex;
        font-family: var(--r5-font-body);
        background-color: var(--r5-nav-bg, transparent);
        padding: var(--r5-nav-padding, 0);
      }

      .vertical {
        flex-direction: column;
        gap: var(--r5-space-1);
      }

      .horizontal {
        flex-direction: row;
        align-items: center;
        gap: var(--r5-space-1);
      }

      /* Collapsed mode (vertical only) */
      .collapsed {
        width: auto;
      }

      .collapsed ::slotted(ark-nav-item) {
        --nav-item-collapsed: 1;
      }

      .collapsed ::slotted(ark-nav-group) {
        --nav-group-collapsed: 1;
      }
    `
];
m([
  i({ type: String, reflect: !0 })
], v.prototype, "orientation", 2);
m([
  i({ type: String, reflect: !0 })
], v.prototype, "size", 2);
m([
  i({ type: Boolean, reflect: !0 })
], v.prototype, "collapsed", 2);
v = m([
  x("ark-nav")
], v);
var _ = Object.defineProperty, z = Object.getOwnPropertyDescriptor, h = (a, r, s, t) => {
  for (var e = t > 1 ? void 0 : t ? z(r, s) : r, o = a.length - 1, l; o >= 0; o--)
    (l = a[o]) && (e = (t ? l(r, s, e) : l(e)) || e);
  return t && e && _(r, s, e), e;
};
let d = class extends b {
  constructor() {
    super(...arguments), this.active = !1, this.disabled = !1, this.indent = 0, this._handleClick = (a) => {
      if (this.disabled) {
        a.preventDefault();
        return;
      }
      this.dispatchEvent(
        new CustomEvent("ark-click", {
          detail: { href: this.href },
          bubbles: !0,
          composed: !0
        })
      );
    };
  }
  render() {
    const a = this.querySelector('[slot="icon"]') !== null, r = this.querySelector('[slot="trailing"]') !== null, s = {
      item: !0,
      active: this.active,
      disabled: this.disabled,
      [`indent-${this.indent}`]: this.indent > 0 && this.indent <= 2
    }, t = n`
      ${a ? n`<span part="icon" class="icon"><slot name="icon"></slot></span>` : p}
      <span part="label" class="label"><slot></slot></span>
      ${r ? n`<span part="trailing" class="trailing"><slot name="trailing"></slot></span>` : p}
    `;
    return this.href && !this.disabled ? n`
        <a
          part="item"
          class=${u(s)}
          href=${this.href}
          @click=${this._handleClick}
        >
          ${t}
        </a>
      ` : n`
      <div
        part="item"
        class=${u(s)}
        role="button"
        tabindex=${this.disabled ? -1 : 0}
        @click=${this._handleClick}
        @keydown=${(e) => {
      (e.key === "Enter" || e.key === " ") && (e.preventDefault(), this._handleClick(e));
    }}
      >
        ${t}
      </div>
    `;
  }
};
d.styles = [
  y,
  g`
      :host {
        display: block;
      }

      *,
      *::before,
      *::after {
        box-sizing: border-box;
      }

      .item {
        display: flex;
        align-items: center;
        gap: var(--r5-space-3);
        padding: var(--r5-nav-item-padding, var(--r5-space-2) var(--r5-space-3));
        border-radius: var(--r5-nav-item-radius, var(--r5-radius-md));
        font-size: var(--r5-text-sm);
        font-weight: var(--r5-font-medium);
        color: var(--r5-text-muted);
        text-decoration: none;
        cursor: pointer;
        transition: all var(--r5-duration-fast) var(--r5-ease-default);
        user-select: none;
        position: relative;
      }

      .item:hover {
        background-color: var(--r5-bg-muted);
        color: var(--r5-text);
      }

      .item:focus-visible {
        outline: 2px solid var(--r5-ring);
        outline-offset: 2px;
      }

      /* Active state */
      .item.active {
        background-color: var(--r5-color-primary-50);
        color: var(--r5-color-primary-700);
        font-weight: var(--r5-font-semibold);
      }

      .item.active::before {
        content: '';
        position: absolute;
        left: 0;
        top: 0.25rem;
        bottom: 0.25rem;
        width: 3px;
        background-color: var(--r5-color-primary-500);
        border-radius: 0 var(--r5-radius-sm) var(--r5-radius-sm) 0;
      }

      .item.active:hover {
        background-color: var(--r5-color-primary-100);
      }

      /* Disabled state */
      .item.disabled {
        opacity: 0.5;
        cursor: not-allowed;
        pointer-events: none;
      }

      /* Icon */
      .icon {
        display: flex;
        align-items: center;
        justify-content: center;
        flex-shrink: 0;
        width: 1.25rem;
        height: 1.25rem;
        color: inherit;
      }

      .icon ::slotted(*) {
        width: 100%;
        height: 100%;
      }

      /* Label */
      .label {
        flex: 1;
        white-space: nowrap;
        overflow: hidden;
        text-overflow: ellipsis;
      }

      /* Trailing */
      .trailing {
        display: flex;
        align-items: center;
        flex-shrink: 0;
        color: var(--r5-text-muted);
        font-size: var(--r5-text-xs);
      }

      /* Collapsed mode (from parent) */
      :host([data-collapsed]) .item {
        justify-content: center;
        padding: var(--r5-space-2);
      }

      :host([data-collapsed]) .label,
      :host([data-collapsed]) .trailing {
        display: none;
      }

      /* Indent for nested items */
      .indent-1 {
        padding-left: calc(var(--r5-space-3) + 1.25rem + var(--r5-space-3));
      }

      .indent-2 {
        padding-left: calc(var(--r5-space-3) + 2.5rem + var(--r5-space-3) + var(--r5-space-3));
      }

      /* Sizes */
      :host([size='sm']) .item {
        padding: var(--r5-space-1-5) var(--r5-space-2);
        font-size: var(--r5-text-xs);
        gap: var(--r5-space-2);
      }

      :host([size='sm']) .icon {
        width: 1rem;
        height: 1rem;
      }

      :host([size='lg']) .item {
        padding: var(--r5-space-3) var(--r5-space-4);
        font-size: var(--r5-text-base);
        gap: var(--r5-space-4);
      }

      :host([size='lg']) .icon {
        width: 1.5rem;
        height: 1.5rem;
      }
    `
];
h([
  i({ type: String })
], d.prototype, "href", 2);
h([
  i({ type: Boolean, reflect: !0 })
], d.prototype, "active", 2);
h([
  i({ type: Boolean, reflect: !0 })
], d.prototype, "disabled", 2);
h([
  i({ type: Number })
], d.prototype, "indent", 2);
h([
  i({ type: String, reflect: !0 })
], d.prototype, "size", 2);
d = h([
  x("ark-nav-item")
], d);
var C = Object.defineProperty, O = Object.getOwnPropertyDescriptor, f = (a, r, s, t) => {
  for (var e = t > 1 ? void 0 : t ? O(r, s) : r, o = a.length - 1, l; o >= 0; o--)
    (l = a[o]) && (e = (t ? l(r, s, e) : l(e)) || e);
  return t && e && C(r, s, e), e;
};
let c = class extends b {
  constructor() {
    super(...arguments), this.label = "", this.collapsible = !0, this.expanded = !1, this.defaultExpanded = !0, this._initialized = !1, this._handleToggle = () => {
      this.collapsible && (this.expanded = !this.expanded, this.dispatchEvent(
        new CustomEvent(this.expanded ? "ark-expand" : "ark-collapse", {
          detail: { label: this.label },
          bubbles: !0,
          composed: !0
        })
      ));
    };
  }
  connectedCallback() {
    super.connectedCallback(), this._initialized || (this.expanded = this.defaultExpanded, this._initialized = !0);
  }
  render() {
    const a = this.querySelector('[slot="icon"]') !== null, r = this.querySelector('[slot="trailing"]') !== null, s = {
      group: !0,
      collapsible: this.collapsible,
      static: !this.collapsible,
      expanded: this.expanded || !this.collapsible
    };
    return n`
      <div class=${u(s)}>
        <div
          part="header"
          class="header"
          role=${this.collapsible ? "button" : "heading"}
          tabindex=${this.collapsible ? 0 : -1}
          aria-expanded=${this.collapsible ? this.expanded : p}
          @click=${this._handleToggle}
          @keydown=${(t) => {
      this.collapsible && (t.key === "Enter" || t.key === " ") && (t.preventDefault(), this._handleToggle());
    }}
        >
          ${a ? n`<span class="icon"><slot name="icon"></slot></span>` : p}
          <span part="label" class="label">${this.label}</span>
          ${r ? n`<span class="trailing"><slot name="trailing"></slot></span>` : p}
          ${this.collapsible ? n`
                <span class="chevron">
                  <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2">
                    <polyline points="9 18 15 12 9 6"/>
                  </svg>
                </span>
              ` : p}
        </div>
        <div part="content" class="content">
          <div class="content-inner">
            <slot></slot>
          </div>
        </div>
      </div>
    `;
  }
};
c.styles = [
  y,
  g`
      :host {
        display: block;
      }

      *,
      *::before,
      *::after {
        box-sizing: border-box;
      }

      .group {
        font-family: var(--r5-font-body);
      }

      /* Header */
      .header {
        display: flex;
        align-items: center;
        gap: var(--r5-space-3);
        padding: var(--r5-space-2) var(--r5-space-3);
        border-radius: var(--r5-radius-md);
        font-size: var(--r5-text-sm);
        font-weight: var(--r5-font-medium);
        color: var(--r5-text-muted);
        cursor: pointer;
        user-select: none;
        transition: all var(--r5-duration-fast) var(--r5-ease-default);
      }

      .header:hover {
        background-color: var(--r5-bg-muted);
        color: var(--r5-text);
      }

      .header:focus-visible {
        outline: 2px solid var(--r5-ring);
        outline-offset: 2px;
      }

      /* Collapsible mode */
      .collapsible .header {
        cursor: pointer;
      }

      /* Non-collapsible (section label) */
      .static .header {
        cursor: default;
        padding: var(--r5-space-3) var(--r5-space-2) var(--r5-space-1);
        font-size: 0.65rem;
        font-weight: var(--r5-font-semibold);
        text-transform: uppercase;
        letter-spacing: 0.08em;
        color: var(--r5-text-muted);
        opacity: 0.7;
      }

      .static .header:hover {
        background-color: transparent;
        color: var(--r5-text-muted);
      }

      /* Add divider above section labels (except first) */
      :host(:not(:first-child)) .static .header {
        margin-top: var(--r5-space-2);
        padding-top: var(--r5-space-3);
        border-top: 1px solid var(--r5-border);
      }

      /* Icon */
      .icon {
        display: flex;
        align-items: center;
        justify-content: center;
        flex-shrink: 0;
        width: 1.25rem;
        height: 1.25rem;
        color: inherit;
      }

      .icon ::slotted(*) {
        width: 100%;
        height: 100%;
      }

      /* Label */
      .label {
        flex: 1;
        white-space: nowrap;
        overflow: hidden;
        text-overflow: ellipsis;
      }

      /* Chevron */
      .chevron {
        display: flex;
        align-items: center;
        justify-content: center;
        flex-shrink: 0;
        width: 1rem;
        height: 1rem;
        color: var(--r5-text-muted);
        transition: transform var(--r5-duration-fast) var(--r5-ease-default);
      }

      .chevron svg {
        width: 100%;
        height: 100%;
      }

      .expanded .chevron {
        transform: rotate(90deg);
      }

      .static .chevron {
        display: none;
      }

      /* Trailing */
      .trailing {
        display: flex;
        align-items: center;
        flex-shrink: 0;
        color: var(--r5-text-muted);
        font-size: var(--r5-text-xs);
      }

      /* Content */
      .content {
        display: grid;
        grid-template-rows: 0fr;
        transition: grid-template-rows var(--r5-duration-normal) var(--r5-ease-default);
      }

      .expanded .content {
        grid-template-rows: 1fr;
      }

      .static .content {
        grid-template-rows: 1fr;
      }

      .content-inner {
        overflow: hidden;
        padding-left: 0;
      }

      .collapsible .content-inner {
        padding-left: calc(1.25rem + var(--r5-space-3));
      }

      /* Collapsed mode (from parent nav) */
      :host([data-collapsed]) .label,
      :host([data-collapsed]) .chevron,
      :host([data-collapsed]) .trailing {
        display: none;
      }

      :host([data-collapsed]) .header {
        justify-content: center;
        padding: var(--r5-space-2);
      }

      :host([data-collapsed]) .content {
        display: none;
      }
    `
];
f([
  i({ type: String })
], c.prototype, "label", 2);
f([
  i({ type: Boolean, reflect: !0 })
], c.prototype, "collapsible", 2);
f([
  i({ type: Boolean, reflect: !0 })
], c.prototype, "expanded", 2);
f([
  i({ type: Boolean, attribute: "default-expanded" })
], c.prototype, "defaultExpanded", 2);
f([
  w()
], c.prototype, "_initialized", 2);
c = f([
  x("ark-nav-group")
], c);
export {
  v as A,
  d as a,
  c as b
};
//# sourceMappingURL=ark-nav-group-BXkPmaTg.js.map
